















































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import Loading from '@c/controls/Loading.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import DeleteDialog from '@c/DeleteDialog.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import router from '@/router';
import diagtaskStoreModule from '@/store/modules/diagtaskModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import bearingsStoreModule from '@/store/modules/bearingsModule';
import {PModuleType} from '@/enums/configs';
import {DiagTaskTableHeader} from './interfaces';

@Component({
  components: {
    IconButton,
    SimpleDialog,
    DeleteDialog,
    CancelChangesDialog,
    Loading,
  },
})
export default class DiagTask extends Vue {
  loading = true;
  error = false;
  saving = false;
  valid = true;
  bearingEditDialog = false;
  bearingAddFlag = false;
  currentBearingItem: any = {};
  currentBearing = '';
  currentComplexity = 1;
  frequencyEditDialog = false;
  frequencyAddFlag = false;
  currentFrequencyName = '';
  currentFrequencyDescription = '';
  currentFrequency = 0;
  currentFrequencyId = -1;
  currentFrequencyAbsolute = false;
  currentFrequencyEnabled = true;

  task: any = {};
  accelerometers: any = [];
  tahometers: any = [];
  bearings: any = [];
  thermometers: any = [];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  bearingsHeaders: DiagTaskTableHeader[] = [
    {
      text: 'Подшипник',
      value: 'bearing.name',
      sortable: true,
    },
    {
      text: 'Множитель частот',
      value: 'complexity',
      sortable: false,
    },
    {
      text: 'Действия',
      value: 'actions',
      sortable: false,
      width: 90,
    },
  ];

  frequenciesHeaders: DiagTaskTableHeader[] = [
    {
      text: 'Название',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: false,
    },
    {
      text: 'Значение',
      value: 'frequency',
      sortable: true,
    },
    {
      text: 'Абсолютная?',
      value: 'is_absolute',
      sortable: false,
    },
    {
      text: 'Включена?',
      value: 'is_enabled',
      sortable: false,
    },
    {
      text: 'Действия',
      value: 'actions',
      sortable: false,
      width: 90,
    },
  ];

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      await diagtaskStoreModule.save(this.task);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push('/diagtasks');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async created() {
    await pmoduleModule.fetchAll();
    await bearingsStoreModule.fetchAll();
    this.bearings = bearingsStoreModule.all;
    this.accelerometers = pmoduleModule.all.filter(
      x => x.type === PModuleType.DtcpAccelerometerModule,
    );
    this.tahometers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpTahoModule);
    this.thermometers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpTemperatureModule);

    const taskId = this.$router.currentRoute.params.id;
    if (taskId) {
      const {data} = await diagtaskStoreModule.edit(taskId);
      this.task = data;
    } else {
      const {data} = await diagtaskStoreModule.create();
      this.task = data;
    }
    this.loading = false;
  }

  addBearing() {
    this.currentBearingItem = {};
    this.currentBearing = '';
    this.currentComplexity = 1;
    this.bearingAddFlag = true;
    this.bearingEditDialog = true;
  }

  editBearing(item: any) {
    this.currentBearingItem = item;
    this.currentBearing = item.bearing.name;
    this.currentComplexity = item.complexity;
    this.bearingAddFlag = false;
    this.bearingEditDialog = true;
  }

  async bearingSettingsChanged() {
    const err_container = this.$refs.err_text as any;
    if (err_container) err_container.innerText = '';
    this.bearingEditDialog = false;
    try {
      if (this.bearingAddFlag) {
        const data = await diagtaskStoreModule.saveBearing({
          id: this.task.id,
          bearing: {
            bearing_id: this.currentBearing,
            complexity: this.currentComplexity,
          },
        });
        this.task = data;
      } else {
        const data = await diagtaskStoreModule.saveBearing({
          id: this.task.id,
          bearing: {
            id: this.currentBearingItem.id,
            bearing_id: this.currentBearingItem.bearing.id,
            complexity: this.currentComplexity,
          },
        });
        this.task = data;
      }
    } catch (e) {
      console.log('failed to save:', e);
      if (err_container) err_container.innerText = 'Ошибка: ' + e;
    }
  }

  async deleteBearing(item: any) {
    const err_container = this.$refs.err_text as any;
    if (err_container) err_container.innerText = '';
    const itemName: string = item.bearing.name;
    const deleteDialog = this.$refs.deleteDialog as any;
    deleteDialog.open(
      {item, itemName},
      {
        deleteCallback: async (elem: any) => {
          deleteDialog.close();
          try {
            const data = await diagtaskStoreModule.delBearing({
              itemId: this.task.id,
              bearingId: elem.item.id,
            });
            this.task = data;
          } catch (e) {
            console.log('failed to delete:', e);
            if (err_container) err_container.innerText = 'Ошибка: ' + e;
          }
        },
      },
    );
  }

  addFrequency() {
    this.currentFrequencyName = '';
    this.currentFrequencyDescription = '';
    this.currentFrequency = 0;
    this.currentFrequencyId = -1;
    this.currentFrequencyAbsolute = false;
    this.currentFrequencyEnabled = true;
    this.frequencyAddFlag = true;
    this.frequencyEditDialog = true;
  }

  editFrequency(item: any) {
    this.currentFrequencyName = item.name;
    this.currentFrequencyDescription = item.description;
    this.currentFrequency = item.frequency;
    this.currentFrequencyId = item.id;
    this.currentFrequencyAbsolute = item.is_absolute;
    this.currentFrequencyEnabled = item.is_enabled;
    this.frequencyAddFlag = false;
    this.frequencyEditDialog = true;
  }

  async frequencySettingsChanged() {
    const err_container = this.$refs.err_text as any;
    if (err_container) err_container.innerText = '';
    this.frequencyEditDialog = false;
    try {
      if (this.frequencyAddFlag) {
        const data = await diagtaskStoreModule.saveFrequency({
          id: this.task.id,
          frequency: {
            name: this.currentFrequencyName,
            description: this.currentFrequencyDescription,
            frequency: this.currentFrequency,
            is_absolute: this.currentFrequencyAbsolute,
            is_enabled: this.currentFrequencyEnabled,
          },
        });
        this.task = data;
      } else {
        const data = await diagtaskStoreModule.saveFrequency({
          id: this.task.id,
          frequency: {
            id: this.currentFrequencyId,
            name: this.currentFrequencyName,
            description: this.currentFrequencyDescription,
            frequency: this.currentFrequency,
            is_absolute: this.currentFrequencyAbsolute,
            is_enabled: this.currentFrequencyEnabled,
          },
        });
        this.task = data;
      }
    } catch (e) {
      console.log('failed to save:', e);
      if (err_container) err_container.innerText = 'Ошибка: ' + e;
    }
  }

  async deleteFrequency(item: any) {
    const err_container = this.$refs.err_text as any;
    if (err_container) err_container.innerText = '';
    const itemName: string = item.name;
    const deleteDialog = this.$refs.deleteDialog as any;
    deleteDialog.open(
      {item, itemName},
      {
        deleteCallback: async (elem: any) => {
          deleteDialog.close();
          try {
            const data = await diagtaskStoreModule.delFrequency({
              itemId: this.task.id,
              frequencyId: elem.item.id,
            });
            this.task = data;
          } catch (e) {
            console.log('failed to delete:', e);
            if (err_container) err_container.innerText = 'Ошибка: ' + e;
          }
        },
      },
    );
  }

  back() {
    const cancelChangesDialog = this.$refs.cancelChangesDialog as any;
    // если были внесены изменения на форме
    if (this.changed) {
      cancelChangesDialog.open('/diagtasks');
    } else router.push('/diagtasks');
  }
}
